import React from "react";
import {JobDescriptionDetailsType} from "../jobDetailsManagementHelper";
import {ApplicationPreview} from "./ApplicationPreview";
import "./styles/styles.css";

type SectionProps = {children?: React.ReactNode; bgColor?: string};
function Section({children, bgColor}: SectionProps) {
    return <div style={{backgroundColor: bgColor}}>{children}</div>;
}

function Paragraph({title, contents}: JobDescriptionDetailsType) {
    return (
        <div className="my-2 py-2">
            <h3 style={{fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.5}}>{title}</h3>
            {contents.map((content, index) => (
                <p key={index}>{content}</p>
            ))}
        </div>
    );
}

function List({title, contents}: JobDescriptionDetailsType) {
    return (
        <div className="my-2 py-2">
            <h3 style={{fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.5}}>{title}</h3>
            <ul className="list-disc list-outside pl-6 space-y-1 leading-relaxed">
                {contents.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </div>
    );
}

function Salary({salary}: {salary: string}) {
    return (
        <div className="my-2 py-2">
            {salary && <h3 style={{fontSize: "1.5rem", fontWeight: 700}}>Pay: ${salary}</h3>}
        </div>
    );
}

function Video({videoUrl}: {videoUrl?: string}) {
    if (!videoUrl) return <></>;

    return (
        <div className="my-4">
            <iframe
                width="100%"
                height="315"
                src={videoUrl}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
    );
}

function BackButton() {
    return (
        <button
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            style={{
                color: "#151751",
                padding: "8px 16px",
                backgroundColor: "#00bf94",
                borderRadius: "20px",
                fontSize: "14px",
            }}
        >
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z"
                    fill="currentColor"
                />
            </svg>
            Back
        </button>
    );
}

function Details() {
    const jobId = window.location.pathname.split("/").pop();
    const stateString = sessionStorage.getItem(`JOB-PREVIEW-${jobId}`);
    if (!stateString) {
        return <div>No preview data found.</div>;
    }

    const state = JSON.parse(stateString);
    const jobTitle: string = state.jobTitle || "Job Title Not Found";
    const sections: JobDescriptionDetailsType[][] = state.sections || [];
    const salary = state.salary || "";

    return (
        <div>
            <h2 className="mt-2" style={{maxWidth: "60vw", lineHeight: 1.5}}>
                {jobTitle}
            </h2>
            {sections.map((section: JobDescriptionDetailsType[], index: number) => (
                <div key={index} className="mb-10 text-left">
                    <Section>
                        {section.map((item: JobDescriptionDetailsType, index) => {
                            switch (item.contentType) {
                                case "PARAGRAPH":
                                    return <Paragraph key={index} {...item} />;
                                case "LIST":
                                    return <List key={index} {...item} />;
                                case "SALARY":
                                    return <Salary key={index} salary={salary} />;
                                case "VIDEO":
                                    return <Video key={index} videoUrl={item.videoUrl} />;
                                default:
                                    return <></>;
                            }
                        })}
                    </Section>
                </div>
            ))}
        </div>
    );
}

export function JobPreview() {
    return (
        <div
            className="page-padding"
            style={{
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
            }}
        >
            <div className="page-padding text-left">
                <BackButton />
                <div className="mx-auto w-full py-5 text-center" style={{maxWidth: "80rem"}}>
                    <h2 className="text-4xl font-bold">[ Job Portal Logo ]</h2>
                </div>
                <div className="mx-auto w-full" style={{maxWidth: "80rem"}}>
                    <div className="flex flex-col gap-10 lg:flex-row lg:items-start">
                        <div className="w-full text-left lg:w-1/2">
                            <Details />
                        </div>
                        <div className="w-full lg:w-1/2">
                            <ApplicationPreview />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
